import React from "react";
/* @flow weak */
/* eslint react/prop-types: 0 */

import PropTypes from "prop-types";
import Validator from "../../helpers/Validator";
import slugify from "slugify";

import styles from "./TextBox.module.css";

const errorStyles = (isEBBHomePage) => {
  return isEBBHomePage ? styles.errorEBBHomePage : styles.error;
};

class TextBox extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    errorClass: PropTypes.string,
    disabled: PropTypes.bool,
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSubmit: PropTypes.func,
    handleOnBlur: PropTypes.func,
    errorMessage: PropTypes.string,
    successMessage: PropTypes.string,
    id: PropTypes.string,
    handleKeyUp: PropTypes.func,
    handleClick: PropTypes.func,
    handleInputSubmit: PropTypes.func,
  };

  static defaultProps = {
    placeholder: "",
    maxLength: "",
    value: "",
    name: "textBox",
    className: "",
    errorClass: "",
    rules: [],
    type: "text",
    disabled: false,
    onChange: () => {},
    onSubmit: () => {},
    onEnter: () => {},
    validateSlug: false,
    errorMessage: null,
    handleClick: () => console.log("handleClick called"),
    handleInputSubmit: () => console.log("handleInputSubmit clicked"),
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      errorClass: errorStyles(this.props.isEBBHomePage),
      valid: false,
      className: this.props.className,
      show: false,
    };

    this.textInput = null;
    this.searchIcon = `${process.env.S3_IMAGE_URL}/black-search-icon.png`;
  }

  focusTextInput = () => {
    if (this.textInput) this.textInput.focus();
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    // Return null if there are no changes to state
    return prevState.value.length > 0 ? { value: prevState.value } : "";
  }

  handleInputChange = (e) => {
    this.props.handleInputChange(e);
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ value });
    if (this.props.handleInputChange && typeof this.props.handleInputChange === "function") {
      this.handleInputChange(value);
    }
  };

  handleSubmit = (event) => {
    let inputValue = event.target.value;
    /**
     * check for when the "enter" key is press in the input and toggle the modal
     * default props is set, so it does not conflic with the desktop header
     **/
    if (event.charCode == 13 || event.key == "Enter") {
      this.props.onEnter();
    }

    if (event.key === "Enter") {
      this.props.handleInputSubmit(inputValue);

      this.setState({
        value: inputValue,
      });
    }
  };

  clearTextBox = () => {
    this.setState({
      value: "",
    });
    return this.state.value;
  };

  formatSlug = (value) => {
    this.setState({
      value: slugify(value),
    });
  };

  /** Checks if slug begins with 'signup/'
   * If not, returns false, otherwise returns 'signup/{slug(value)}'
   */
  formatFunnelSlug = (value) => {
    if (value.indexOf("signup/") !== 0) {
      return false;
    } else {
      let slugVal = value.slice(value.indexOf("/") + 1);

      if (!slugVal) {
        return "signup";
      }
      return value.replace(slugVal, slugify(slugVal));
    }
  };

  validate = (evt) => {
    let rules = this.props.rules,
      month = this.props.month;
    if (this.props.validateSlug) {
      this.formatSlug(this.state.value);
    }

    if (this.props.validateFunnelSlug) {
      const slug = this.formatFunnelSlug(this.state.value);
      if (slug) {
        this.setState({
          value: slug,
          errorClass: errorStyles(this.props.isEBBHomePage),
          className: " ",
        });
      } else {
        this.setState(
          {
            errorClass: errorStyles(this.props.isEBBHomePage),
            errorMsg: "Slug must begin with 'signup/'",
            className: "red-border",
          },
          () => {
            return false;
          }
        );
        return false;
      }
    }

    if (this.props.handleOnBlur && evt) {
      this.props.handleOnBlur(evt);
    }

    if (rules && this.state.value.length > 0) {
      let results = Validator.validate(this.state.value, rules, month);

      if (results.length > 0) {
        let error = results[0];

        this.setState(
          {
            errorClass: errorStyles(this.props.isEBBHomePage),
            errorMsg: error.msg,
            className: "red-border",
          },
          () => {
            return false;
          }
        );

        return false;
      } else {
        this.setState(
          {
            errorClass: errorStyles(this.props.isEBBHomePage),
            className: " ",
          },
          () => {
            return true;
          }
        );

        return true;
      }
    }

    return true;
  };

  getValue = () => {
    return this.state.value;
  };

  autoFocusChecker = () => {
    // majority of components come from Button Link
    const NO_FOCUS_SET = new Set(["Newsletter", "Button Link", "Image", "Book Excerpt"]);
    if (NO_FOCUS_SET.has(this.props.inherited)) return false;
    return true;
  };

  onKeyDown = (event) => {
    this.setState({ keycode: event.keyCode });
  };

  render() {
    let errorClass = this.props.errorClass
      ? this.props.errorClass
      : this.state.errorClass || errorStyles(this.props.isEBBHomePage);

    return (
      <div className={`${this.props.className} ${styles.textBox} textBox`}>
        <div className={styles["input-group"]}>
          <input
            //autoFocus={this.autoFocusChecker()}
            id={this.props.id}
            type={this.props?.type === "password" && this.state.show ? "text" : this.props?.type}
            placeholder={this.props.placeholder}
            // ref={(element) => this.textInput = element}
            ref={this.props.inputRef}
            name={this.props.name}
            onChange={this.handleChange}
            className={`${this.state.className} ${this.props.textBoxInputClass}`}
            onBlur={(evt) => {
              let isValid = this.validate(evt);
              if (this.props && this.props.handleIsValid) {
                this?.props?.handleIsValid(isValid);
              }
            }}
            value={this.state.value}
            disabled={this.props.disabled}
            size={this.props.size}
            maxLength={this.props.maxLength ? this.props.maxLength : 10000}
            onKeyPress={this.handleSubmit}
            onKeyUp={this.handleKeyUp}
            onKeyDown={this.onKeyDown}
            onClick={this.handleClick}
            style={this.props.style}
            max={this.props.max}
          />
          {this.props.renderEyeIcon ? (
            this.state.show ? (
              <img
                src={`${process.env.S3_IMAGE_URL}/Hide-Password-Icon.svg`}
                className={styles["eye-icon"]}
                onClick={() => this.setState({ show: false })}
              />
            ) : (
              <img
                src={`${process.env.S3_IMAGE_URL}/Show-Password-Icon.svg`}
                className={styles["eye-icon"]}
                onClick={() => this.setState({ show: true })}
              />
            )
          ) : null}
        </div>
        {this.props.isEBBHomePage && !this.props.errorMessage && !this.props.successMessage ? (
          <div style={{ height: "1.5rem" }}></div>
        ) : null}
        {this.props.errorMessage ? (
          <small className={`${styles.msgBlock} ${errorClass}`}>{this.props.errorMessage}</small>
        ) : null}
        {this.props.successMessage ? (
          <small
            className={[
              styles.success,
              this.props.parentClass?.successClass,
              styles.msgBlock,
              this.props.parentClass?.msgBlockClass,
            ].join(" ")}
          >
            {this.props.successMessage}
          </small>
        ) : null}
        <style jsx>
          {`
            .whiteColor {
              color: #fff;
            }
            input#searchBox {
              padding: 10px 15px;
              background-image: url(${this.searchIcon});
              background-repeat: no-repeat;
              background-position: 98% center;
              background-size: 18px;
              width: 100%;
            }
            .textBox input.headerSearch {
              border-right: 1px solid #dfe3e6;
            }
            input.newsLettetPb.dealspage__newsletter,
            .newsLettetPb input {
              height: 41px;
              border-radius: 0px;
              background: #fff;
              width: 100%;
              border-right: none;
            }
            .newsLettetPb input {
              border: 0;
              height: 58px;
              padding: 0px 10px;
              font-size: 16px;
              border-radius: 5px 0 0 5px;
              border: 1px solid #000;
            }
            input.newOne {
              max-width: calc(100% - 10px);
            }
            input.groupButton {
              max-width: 100%;
              height: 45px;
              border-radius: 4px 0 0 4px;
            }
            .newsLettetPb input::placeholder {
              color: #333;
            }
            .overlay .inputBox .textBox input,
            .overlay .buttonBox button {
              padding: 15px 5px;
              font-size: 16px;
            }
            @media (max-width: 1265px) {
              .textBox .expandSearch {
                padding: 10px 15px;
              }
            }
            @media (max-width: 575px) {
              .newsLettetPb input {
                max-width: 100%;
                margin-right: 0px;
              }
              input.headerSearch,
              input.newOne {
                width: 100%;
                max-width: 100%;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default TextBox;
